import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-organisation-modal',
  templateUrl: './create-organisation-modal.component.html',
  styleUrls: ['./create-organisation-modal.component.css']
})
export class CreateOrganisationModalComponent implements OnInit {

  constructor(private dialog: MatDialogRef<CreateOrganisationModalComponent>, private snack: MatSnackBar) { }
  @Input() workspaceType!: string;

  ngOnInit(): void {
  }

  CreateOrganisation(businessName: string) {
      this.dialog.close(businessName);
  }

}
